import { PropsWithChildren } from "react";
import { cn } from "@/lib/utils";
import { Required } from "./required";
/**
 * Props for the Label component
 */
interface LabelProps extends PropsWithChildren {
    /** Id of the input field */
    inputId?: string;
    /** True when the label is required */
    required?: boolean;
    /** True when the label is bold */
    bold?: boolean;
}

/**
 * Component that displays a label
 */
export const Label: React.FC<LabelProps> = ({ children, inputId, required, bold = true }) => {
    return (
        <label className={cn("text-sm font-medium", bold && "font-bold")} htmlFor={inputId}>
            {children}
            {required && <Required />}
        </label>
    );
};
